import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import DeletionBucketSection from 'app/components/DeletionBucketSection';
import { CustomerBillHistoryHeader } from 'app/constants/table-header-constants';
import { ParseTableDate } from 'app/utils/Parsers';
import Excel from 'assets/images/xls-icon.svg';
import useCustomerBillHistory from './useCustomerBillHistory';

const CustomerBillHistory = ({ latestDeletionDate, latestRestorationDate }) => {
  const {
    pageLoading,

    flatData,
    flatTotal,
    flatPageCount,
    fetchFlat,

    beforeData,
    beforeTotal,
    beforePageCount,
    fetchBefore,

    afterData,
    afterTotal,
    afterPageCount,
    fetchAfter,

    dataPerPage,

    startDownload,
    downloadInProgress,
  } = useCustomerBillHistory(latestDeletionDate, latestRestorationDate);

  // Async Excel export (job → poll → download), same flow + Excel icon and
  // in-flight treatment as the reports' export.
  const exportBar = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 12,
      }}
    >
      <span
        className='link cursor-pointer download'
        style={
          downloadInProgress
            ? { opacity: 0.5, cursor: 'not-allowed' }
            : undefined
        }
        onClick={() => !downloadInProgress && startDownload('excel')}
      >
        <img alt='excel' src={Excel} />
      </span>
      {downloadInProgress && (
        <span
          style={{
            marginLeft: 8,
            fontSize: '0.85rem',
            color: '#666',
            fontStyle: 'italic',
          }}
        >
          Generating report…
        </span>
      )}
    </div>
  );

  // Never-deleted: render flat, exactly as today.
  if (!latestDeletionDate) {
    return (
      <>
        <div className='cms-content__container'>
          {exportBar}
          <PaginatedTable
            columns={CustomerBillHistoryHeader}
            data={flatData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={flatTotal}
            pageCount={flatPageCount}
            pageLoading={pageLoading}
            fetchData={fetchFlat}
          />
        </div>
        {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
      </>
    );
  }

  const boundaryFormatted = ParseTableDate(latestDeletionDate);
  const restorationFormatted = latestRestorationDate
    ? ParseTableDate(latestRestorationDate)
    : undefined;
  return (
    <>
      <div className='cms-content__container'>
        {exportBar}
        <DeletionBucketSection
          title='Account restored'
          captionDate={restorationFormatted}
          captionPrefix='Account restored on'
          isEmpty={afterData.length === 0}
        >
          <PaginatedTable
            columns={CustomerBillHistoryHeader}
            data={afterData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={afterTotal}
            pageCount={afterPageCount}
            pageLoading={pageLoading}
            fetchData={fetchAfter}
          />
        </DeletionBucketSection>
        <DeletionBucketSection
          title='Account deleted'
          captionDate={boundaryFormatted}
          isEmpty={beforeData.length === 0}
        >
          <PaginatedTable
            columns={CustomerBillHistoryHeader}
            data={beforeData}
            currentPage={1}
            dataPerPage={dataPerPage}
            totalNumber={beforeTotal}
            pageCount={beforePageCount}
            pageLoading={pageLoading}
            fetchData={fetchBefore}
          />
        </DeletionBucketSection>
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CustomerBillHistory;
